/*
 * @Author: your name
 * @Date: 2020-09-15 17:37:45
 * @LastEditTime: 2020-10-08 21:20:49
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \hhy-web\src\minix\index.js
 */
//keep-alive缓存管理
let $math = require('mathjs');
// import $math from "mathjs";
export default {
    computed: {
        cached() {
            return this.$store.state.sharing.cached;
        },
        cachedViews() {
            return this.$store.state.sharing.cachedViews;
        }
    },
    mounted() {
        this._path = this.$route.path;
        console.log('open : ', this._path);
        // Vue.prototype.add = this.accAdd(v,k);
    },
    watch: {
        // cached(e) {
        //   let path = this._path;
        //   if (e.indexOf(path) < 0) {
        //     console.log("destroy : ", path);
        //     this.$destroy()
        //   }
        // },
        cachedViews(e) {
            let name = this.$options.name;
            if (!e.split(',').includes(name)) {
                this.$destroy()
            }
        }
    },
    methods: {
        addS() {
            return this.comp('add', arguments)
        },
        subtractS() {
            return this.comp('subtract', arguments)
        },
        multiplyS() {
            return this.comp('multiply', arguments)
        },
        divideS() {
            return this.comp('divide', arguments)
        },
        comp(_func, args) {
            let t = $math.chain($math.bignumber(args[0]));
            for (let i = 1; i < args.length; i++) {
                t = t[_func]($math.bignumber(args[i]))
            }
            // 防止超过6位使用科学计数法
            return parseFloat(t.done())
        },
        getNumber(val) {
            return Number(val) ? Number(val) : 0
        },
        getNumberOne(val) {
            return Number(val) ? Number(val) : 1
        },
        //加法函数
        accAdd(a, b) {
            [a, b] = [this.getNumber(a), this.getNumber(b)]
            return _.add(a, b);
        },
        sum(arr) {
            return arr.reduce(this.accAdd)
        },
        //减法函数
        accSubtr(arg1, arg2) {
            [arg1, arg2] = [this.getNumber(arg1), this.getNumber(arg2)]
            return _.subtract(arg1, arg2);
        },
        subtract(arr) {
            return arr.reduce(this.accSubtr)
        },
        //除法
        accDiv(a, b) {
            [a, b] = [this.getNumberOne(a), this.getNumberOne(b)]
            return _.divide(a, b);
        },
        divide(arr) {
            return arr.reduce(this.accDiv)
        },
        // 乘法
        accMul(a, b) {
            [a, b] = [this.getNumberOne(a), this.getNumberOne(b)]
            return _.multiply(a, b);
        },
        multiply(arr) {
            return arr.reduce(this.accMul)
        },
        //消息通知
        notice(type, msg) {
            this.$message({
                type: type,
                message: msg
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/minix/index.js